import {
  FontWeights,
  IButtonStyles,
  ICalloutContentStyles,
  ICalloutProps,
  IIconStyles,
  ILinkStyles,
  IMessageBarStyles,
  IScrollablePaneStyles,
  IStackStyles,
  IStyle,
  ITextStyles,
  ITheme,
} from '@fluentui/react';
import { IPalette } from '@fluentui/react/lib/Styling';
import { createPalette } from '../../utils/getHelputils';
export interface IAutoSuggestCardStyles {
  root: IStyle;
  list: IStyle;
  header: IStyle;
  icon: IStyle;
  linkContainer: IStyle;
}
export interface IEndOfLifeCardStyleProps {
  theme: ITheme;
}

export interface IEndOfLifeCardStyles {
  root: IStackStyles;
}

export const CardHeight = 335;

export const commonSearchesHeaderStyle: ITextStyles = {
  root: {
    height: '20px',
    padding: '0px 0px 6px 0px',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '20px',
  },
};

export const commonSearchesSearchIconStyle = (textColor: string): Partial<ILinkStyles> => ({
  root: {
    width: '14px',
    height: '14px',
    fontWeight: '400',
    marginRight: '8px',
    marginTop: '8px',
    color: textColor,
  },
});

export const commonSearchesQueryLinkStyle = (textColor: string): Partial<ILinkStyles> => ({
  root: {
    marginTop: '4px',
    marginBottom: '4px',
    height: '20px',
    fontSize: '14px',
    fontWeight: '400',
    color: textColor,
    selectors: {
      '&:hover, &:focus': {
        cursor: 'pointer',
        color: textColor,
      },
    },
  },
});

export const topResultStackCardStyle = (color: string, expanded: boolean = true): IStackStyles => ({
  root: {
    background: color,
    margin: '20px 0px 20px 0px',
    padding: '25px',
    maxHeight: expanded ? 'fit-content' : CardHeight,
    position: 'relative',
    borderRadius: '4px',
  },
});

export const SAMessageBoxSearchCardStyle = (isDarkTheme: boolean, theme:ITheme): IMessageBarStyles => ({
  root:{
    backgroundColor : isDarkTheme? '#433519' : '#FFF4CE',
    marginTop: '20px',
  },
  icon: {
    color: theme.palette.yellowDark
  },
  text: {
    color: theme.palette.neutralDark
  },
});

export const SAMessageBoxContactSupportCardStyle = (isDarkTheme: boolean, theme:ITheme): IMessageBarStyles => ({
  root:{
    backgroundColor : isDarkTheme? '#442726' : '#FDE7E9',
  },
  icon : {
    color: theme.palette.red},
  text:{
    color: theme.palette.neutralDark},
});

export const MessageBarButtonStyle = {
  textAlign: 'left' as const,
  marginTop: '15px',
  marginRight: '0',
  marginBottom: '10px',
  marginLeft: '0'
};

export const shevronIconStyle = (): IIconStyles => ({
  root: {
    flexGrow: 1,
    cursor: 'pointer',
    display: 'inline',
    fontSize: '18px',
    lineHeight: '16px',
    '@media only screen and (max-width: 480px) ': {
      fontSize: '16px',
      lineHeight: '14px',
    },
  },
});

export const resultHeaderStyle: ITextStyles = {
  root: {
    padding: '12px 0px 12px 0px',
    fontWeight: '600',
    fontSize: 14,
  },
};

export const ResultTitleStyle: ITextStyles = {
  root: {
    width: 'fit-content',
    fontWeight: 600,
    fontSize: '14px',
    margin: '0px 0px 6px 0px',
    // Todo: Brook set title to fitcontent when icon is not shown and move styles to web
    flexGrow: 9,
  },
};

export const FeedbackStyle: ITextStyles = {
  root: {
    textAlign: 'right',
    fontSize: '10px',
    display: 'inline-block',
    width: '100%'
  }
};

export const IconToolTipStyle: ITextStyles = {
  root: {
    display:'inline-block',
    paddingLeft: '10px',
    verticalAlign: 'middle'
  }
};

export const LinkTipStyle: ITextStyles = {
  root: {
    paddingTop: '10px',
    display:'inline-block',
    paddingLeft: '10px',
  }
};

export const ExpandLinkStyle = (backgroundColor: string, textColor: string): ILinkStyles => ({
  root: {
    position: 'absolute',
    bottom: 24,
    left: 0,
    width: '100%',
    padding: '6px 25px 0px 25px',
    fontSize: 'small',
    backgroundColor: backgroundColor,
    color: textColor,
    selectors: {
      '&:hover, &:focus': {
        cursor: 'pointer',
        color: textColor,
      },
    },
  },
});

export const ReadTheArticleLinkStyle = (textColor: string): ILinkStyles => ({
  root: {
    width: 'fit-content',
    padding: '6px 0px',
    fontSize: 'small',
    color: textColor,
    selectors: {
      a: {
        color: textColor,
        ':hover, :focus': {
          cursor: 'pointer',
          color: textColor,
        },
      },
      '&:hover, &:focus': {
        cursor: 'pointer',
        color: textColor,
      },
    },
  },
});

export const TagStackStyle = (color: string): IStackStyles => ({
  root: {
    background: color,
    padding: '3px 6px',
    width: 'fit-content',
    borderRadius: '4px',
    fontWeight: 700,
    fontSize: '8px',
    margin: '0px 0px 6px 0px',
    letterSpacing: '1px',
  },
});

export const RecommendedArticleStackStyle: IStackStyles = {
  root: {
    margin: '24px 0px',
  },
};

export const ContentStyle: ITextStyles = {
  root: {
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    marginBottom: '10px',
  },
};

export const cherryHillButtonStyles: IButtonStyles = {
  root: {
    borderColor: 'rgba(0, 0, 0, 0.06) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.16)',
    borderRadius: '3px',
    height: '30px',
    padding: '0px 11px',
  },
  label: {
    fontWeight: FontWeights.regular,
  },
};

export const teamsSupportButtonStyles: IButtonStyles = {
  root: {
    borderRadius: '3px',
    height: '30px',
    padding: '0px 11px',
    cursor: 'pointer',
  },
  label: {
    fontWeight: FontWeights.regular,
  },
};

export const getAppBarStyles = (theme: ITheme): IStackStyles => ({
  root: {
    height: '44px',
    padding: '0px 0px 0px 35px',
    backgroundColor: theme.palette.neutralLighterAlt,
    outline: 0,
  },
});

export const ratingCaptionStyles: ITextStyles = { root: { marginRight: '5px' } };

export const appBarToolTipCalloutProps: ICalloutProps = { isBeakVisible: false };

export const getAppBarButtonStyles = (theme: ITheme): IButtonStyles => ({
  rootHovered: {
    background: theme.palette.neutralLight,
    borderRadius: '3px',
  },
  root: {
    color: theme.palette.neutralPrimary,
    width: '34px',
    height: '34px',
    margin: '0 2px',
  },
});

export const selfHelpButtonStyles = (theme: ITheme): IButtonStyles => ({
  root: {
    borderColor: 'rgba(0, 0, 0, 0.06) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.16)',
    borderRadius: '3px',
    height: '30px',
    padding: '0px 11px',
    backgroundColor: theme.palette.neutralLighterAlt,
  },
  label: {
    fontWeight: FontWeights.regular,
  },
});

export const baseStyles = (props: IEndOfLifeCardStyleProps): IEndOfLifeCardStyles => ({
  root: {
    root: {
      background: props.theme.palette.neutralLight,
      marginBottom: '30px',
      padding: '16px',
      position: 'relative',
      borderRadius: '4px',
      lineHeight: '20px',
    },
  },
});

// Default palette for GetHelp. If the second parameter to
// createPalette isn't 'Dark', a non-inverted theme is assumed.
var getHelpPalette: Partial<IPalette> = createPalette(null, null);

export const aboutCallOutStackStyles: IStackStyles = {
  root: {
    padding: '20px',
    'a:focus': {
      '@media (prefers-color-scheme: dark)': {
        boxShadow: `inset 0 0 0 1px ${getHelpPalette.neutralLight}`,
        outline: `1px auto ${getHelpPalette.neutralLight}`,
      },
      '@media (prefers-color-scheme: light), ': {
        boxShadow: `inset 0 0 0 1px ${getHelpPalette.neutralDark}`,
        outline: `1px auto ${getHelpPalette.neutralDark}`,
      },
    },
  },
};

export const ticketButtonStyles: IButtonStyles = { root: { width: 'fit-content', display: 'table', padding: '0px' } };

export const getContentScrollablePaneStyles = (theme: ITheme, showAppBar: boolean): Partial<IScrollablePaneStyles> => ({
  contentContainer: {
    position: 'fixed',
    top: showAppBar ? '44px' : '0px',
    bottom: '0px',
    background: theme.palette.neutralLighterAlt,
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
  },
  root: { top: showAppBar ? '44px' : '0px' },
});

export const getContentRootStyles = (inArticle?: boolean): IStackStyles => ({
  root: {
    width: '100%',
    minWidth: '400px',
    maxWidth: inArticle ? undefined : '696px',
    padding: inArticle ? undefined : '0px 48px 30px 48px',
    zIndex: 1,
    flexGrow: 1,
  },
});

export const getSearchAutoSuggestCalloutStyle = (
  backgroundColor: string,
  borderColor: string
): Partial<ICalloutContentStyles> => ({
  root: {
    zIndex: 1,
    display: 'block',
    overflow: 'hidden',
    borderRadius: '0px 0px 7px 7px',
    boxShadow: '0px 0.6px 1.8px rgba(0, 0, 0, 0.108), 0px 3.2px 7.2px rgba(0, 0, 0, 0.132)',
    backgroundColor: backgroundColor,
    borderColor: borderColor,
    border: '1px',
  },
  calloutMain: {
    backgroundColor: backgroundColor,
  },
});

export const getServiceAgreementFooterStyle = (theme: ITheme): ITextStyles => ({
  root: {
    fontWeight: 400,
    padding: '11px 0px 0px 0px',
    lineHeight: '20px',
    color: theme.palette.neutralSecondary,
  },
});

export const getOpenItNowLinkStyle = (theme: ITheme): ILinkStyles => ({
  root: {
    padding: '0px 0px 0px 7px',
    fontSize: '14px',
    color: theme.palette.themeDarkAlt,
    selectors: {
      '&:hover, &:focus': {
        cursor: 'pointer',
        color: theme.palette.themeDarkAlt,
      },
    },
  },
});
